export enum ROSA_QUERY_KEYS {
	GET_ROSA = 'get-rosa',
	GET_RESULT = 'get-rosa-result',
	GET_SCORES = 'get-rosa-scores',
	GET_ELEMENTS = 'get-rosa-elements',
	GET_ROSA_IMAGES = 'get-rosa-images',
	GET_EQUIPMENTS = 'get-rosa-equipments',
	GET_CATEGORIES = 'get-rosa-categories',
	GET_REQUIRED_EQUIPMENTS = 'get-rosa-required-equipments'
}
